import * as React from 'react'
import { Box, Chip } from '@mui/material'
import { Typography as MIUTypography } from '@mui/material'
import { styled } from '@mui/material/styles'

const Typography = styled(MIUTypography)(props => ({
  fontFamily: props.theme.typography.fontFamily,
  fontStyle: 'normal',
  fontSize: '0.8em',
  fontWeight: props.istitle ? 600 : 500,
  lineHeight: 1,
  color: props.islabel ? '#6A6A6A' : '#1B1C37',
  textAlign: props.islabel ? 'start' : 'center',
}))

const CustomizedBox = ({
  gridColumn = 'span 1',
  label,
  valueL,
  bcolor,
  enableChip = false,
  stylePropText,
  stylePropChip,
  medium,
}) => {
  return !enableChip ? (
    <Box gridColumn={gridColumn} sx={{ alignSelf: 'center' }}>
      <Typography component="div" islabel={1} sx={stylePropText}>
        {label}
      </Typography>
    </Box>
  ) : (
    <Chip
      label={valueL}
      style={{
        fontSize: 14,
        backgroundColor:
          bcolor === 1
            ? '#FAEAD2CC'
            : bcolor === 2
            ? '#c1f8abcc'
            : bcolor === 3
            ? 'transparent'
            : bcolor,
        height: 20,
        width: '100%',
        justifySelf: medium ? 'center' : undefined,
        placeSelf: 'center',
        ...stylePropChip,
      }}
    />
  )
}

export default CustomizedBox
